import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2fejdfc9n: FaireProductEntity = {
  token: "p_m2fejdfc9n",
  type: "product",
  name: "Teeny-Tiny Air Hockey",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/0603494c88c3d9aef70c752c8b2458291149f079ad9f78318a753eb6a8b55ddc.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.98,
  description: "Grab your mini mallets and get ready to send the puck flying in this miniature 2 3/4 x 7 inch desktop version of the beloved arcade classic! Arcade nostalgia in a desktop size: The 7-inch long, fan-powered air hockey table fits in the palm of your hand, and with 2 mini paddles and pucks all housed in a 2 7/8 x 3 3/4 inch box, this game is easy to take anywhere for on-the-go fun or display on your desk for a quick mid-day challenge. Easily keep score: Built-in score counters on each end make it simple to track every point. Miniature book included: Comes with a 32-page miniature book filled with the history and rules of air hockey, plus fun trivia and gameplay ideas. Latest RP Minis desktop game: Teeny-Tiny Air Hockey joins the RP Mini Games series alongside our miniature foosball, golf, pickleball, shuffleboard, and more! Requires four AAA batteries (not included).",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:40.892Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
